import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types'
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import validator from 'validator';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//components
//styles
import './login.styl';
import './ResetPass.styl';
import 'bootstrap/dist/css/bootstrap.css';
//text
import ResetText from '../input-text/en/reset';
//config
const baseUrl = require('Config').baseUrl;

class ResetPass extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      password: '',
      passwordConf: '',
      popupText: 'Processing... Just a moment please...',
      loginToken: '',
      success: false
    }
  }

  componentWillMount = () => {

    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const hash = params.get('hash');

    const loginToken = localStorage.getItem('token') || hash;
    if(!loginToken){
      this.context.router.history.push('/');
    }
    this.setState({ loginToken });
  }

  validate = () => {
    //sanitize input
    this.setState({
      password: validator.escape(this.state.password)
    });

    let valid_password = validator.isByteLength(this.state.password, {min: 6, max: undefined});
    let valid_conf = validator.isByteLength(this.state.passwordConf, {min: 6, max: undefined});
    let pass_match = (this.state.password === this.state.passwordConf);

    if(!valid_password){
      this.setState({popupText: 'Password should be at least 6 characters long'});
      return false;
    }
    else if(!valid_conf){
      this.setState({popupText: 'Password should be at least 6 chatacters long'})
    }
    else if(!pass_match){
      this.setState({popupText: 'Passwords do not match, please try again'});
      return false;
    }
    else{
      return (valid_password && pass_match);
    }
  }

  inputChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({popupText: 'Just a moment...'});

    const url = `${baseUrl}/users/resetpass`;

    if(this.validate()){
      axios({
        method: 'POST',
        url: url,
        data: { password: this.state.password },
        headers: {'x-logged-user': this.state.loginToken},
      })
      .then(response => {
        this.success();
      })
      .catch(err => {
        this.setState({popupText: err.response.data.status});
      });
    }
  }

  popup = () => {
    return (
      <Tooltip className="in" id="tooltip-top">
        <span>{this.state.popupText}</span>
      </Tooltip>
    );
  }

  success = () => {
    this.setState({success: true});
    setTimeout(()=>{
      this.context.router.history.push('/dashboard');
    }, 1500);
  }

  render(){
    if(!this.state.success){
      return (
        <SimpleContainer color='dark' containerClass='form-container padded-container header-container'>
          <div className="container">
            <div className='login-form-wrapper'>
              <h1 className='reset-pass__title login-form-title'>{ResetText._1}</h1>
              <form className='reset-pass-form form-body' onSubmit={this.submitForm}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="sign-up-page__form__input-field">
                      <label htmlFor="password" className='form-text'>{ResetText._2}<sup>*</sup></label>
                      <input id="password" type='password' name='password' className='input password' value={this.state.password} onChange={this.inputChange} />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="sign-up-page__form__input-field">
                      <label htmlFor="passwordConf" className='form-text'>{ResetText._3}<sup>*</sup></label>
                      <input id="passwordConf" type='password' name='passwordConf' className='input password' value={this.state.passwordConf} onChange={this.inputChange} />
                    </div>
                  </div>
                </div>
                <div className="right-align">
                  <OverlayTrigger className='form-overlay' trigger={'focus'} placement="bottom" overlay={this.popup()}>
                    <button type="submit" className="button">{ResetText._4}</button>
                  </OverlayTrigger>
                </div>
              </form>
            </div>
          </div>
        </SimpleContainer>
      );
    }
    else {
      return (
        <SimpleContainer color='white' containerClass='form-container padded-container header-container'>
          <h1>Password reset successfully!</h1>
        </SimpleContainer>
      );
    }
  }
};

ResetPass.contextTypes = {
  router: PropTypes.object.isRequired
}
export default ResetPass;



// WEBPACK FOOTER //
// ./src/routes/ResetPass.js